export const oneTimePasswordPath = '/payments'
